import { Component, OnInit } from '@angular/core';
import { ClasseAvaliacao } from '../../../../types/ClasseAvaliacao.type';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-classeavaliacao',
  templateUrl: './classeavaliacao.component.html',
  styleUrl: './classeavaliacao.component.css',
  providers: [ConfirmationService]
})
export class ClasseAvaliacaoComponent implements OnInit {

  loading: boolean = false;
  classeAvaliacoes: ClasseAvaliacao[] = []

  constructor(private integradorService: IntegradorService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarClasseAvaliacao();
  }

  carregarClasseAvaliacao(){
    this.loading = true;
    this.classeAvaliacoes = [];
    this.integradorService.getClassesAvaliacoes().subscribe({
      next: (data) => {
        this.classeAvaliacoes = data
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  excluir(id: string){
    this.integradorService.deleteClasseAvaliacao(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Classe Avaliacao excluída com sucesso");
        this.carregarClasseAvaliacao();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
